import React, {
  useState,
  //  useEffect
} from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
// import DatePicker from "sassy-datepicker";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 3,
};

export default function MobileDashboardCalender({ children }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <button
        className="bg-white px-6 py-1 rounded-lg shadow-sm"
        onClick={handleOpen}
      >
        <span className="font-bold text-gray-600">Select Date</span>
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>{children}</Box>
      </Modal>
    </div>
  );
}
// {children}
